<ng-container *ngIf="viewModel$ | async as viewModel">
  <section class="p-mt-4">
    <header>
      <div class="p-d-flex gap-2">
        <div class="content">
          <span class="value">
            {{ viewModel.customerName }}
          </span>
          <span class="label">Customer</span>
        </div>
        <p-tag
          value="New Customer"
          *ngIf="viewModel.showNewCustomerTag"
          severity="Success"
        ></p-tag>
      </div>
      <button
        pButton
        *ngIf="!viewModel.isEditMode; else cancelButton"
        class="editButton"
        [icon]="viewModel.mutating ? 'pi pi-spin pi-spinner' : 'pi pi-pencil'"
        [text]="true"
        (click)="store.dispatch(actions.editCustomerButtonClicked())"
        [disabled]="viewModel.editButtonDisabled"
      ></button>
    </header>
    <hr />
    <ng-container *ngIf="viewModel.jobLoaded; else loading">
      <main *ngIf="!viewModel.isEditMode; else customerEditForm">
        <div class="details" *ngIf="viewModel.customer">
          <span class="title">Email:</span>
          <span class="data">
            <a
              *ngIf="viewModel.customer.email"
              href="mailto:{{ viewModel.customer.email }}"
            >
              {{ viewModel.customer.email }}
            </a>
            <a
              class="set"
              *ngIf="!viewModel.customer.email"
              (click)="store.dispatch(actions.setCustomerEmailButtonClicked())"
            >
              Set
            </a>
          </span>
          <button
            *ngIf="viewModel.customer.email"
            pButton
            icon="pi pi-clipboard"
            [text]="true"
            pTooltip="Copy email"
            (click)="
              store.dispatch(
                actions.clipboardButtonClicked({
                  content: viewModel.customer.email,
                })
              )
            "
          ></button>
          <button
            *ngIf="viewModel.customer.email"
            pButton
            icon="pi pi-at"
            [text]="true"
            pTooltip="Send Email to Customer"
            (click)="
              store.dispatch(
                actions.sendMessageToCustomer({
                  commentModeId: 'Send Email to Customer',
                })
              )
            "
          ></button>
        </div>
        <div class="details" *ngIf="viewModel.customer">
          <span class="title">Phone:</span>
          <span class="data">
            <a
              *ngIf="viewModel.customer.phone"
              href="tel:{{ viewModel.customer.phone }}"
            >
              {{ viewModel.customer | phone }}
            </a>
            <a
              class="set"
              *ngIf="!viewModel.customer.phone"
              (click)="store.dispatch(actions.setCustomerPhoneButtonClicked())"
            >
              Set
            </a>
          </span>
          <button
            *ngIf="viewModel.customer.phone"
            pButton
            icon="pi pi-clipboard"
            [text]="true"
            pTooltip="Copy phone"
            (click)="
              store.dispatch(
                actions.clipboardButtonClicked({
                  content: viewModel.customer.phone,
                })
              )
            "
          ></button>
          <button
            *ngIf="viewModel.customer.phone"
            pButton
            icon="pi pi-mobile"
            [text]="true"
            pTooltip="Send SMS to Customer"
            (click)="
              store.dispatch(
                actions.sendMessageToCustomer({
                  commentModeId: 'Send SMS to Customer',
                })
              )
            "
          ></button>
        </div>
        <div class="details" *ngIf="viewModel.customer?.additionalContacts?.length">
          <span class="title">Additional contacts:</span>
        </div>

        <div
            class="details additional-contacts"
            *ngFor="let contact of viewModel.customer.additionalContacts"
          >
            <span class="title">
              {{ contact.name || 'Contact' }}<span *ngIf="contact.relationship"> ({{ contact.relationship }})</span>:
            </span>
            <span class="data">
              <a *ngIf="contact.email" href="mailto:{{ contact.email }}">{{ contact.email }}</a>
              <span *ngIf="contact.email && contact.phone"> | </span>
              <a *ngIf="contact.phone" href="tel:{{ contact.phone }}">{{ contact.phone }}</a>
            </span>
          </div>

        <div class="details" *ngIf="viewModel.job.timeline">
          <span class="title">Timeline:</span>
          <span class="data">
            {{
              viewModel.job.timeline | jobTimeline: viewModel.job.timelineDays
            }}</span
          >
        </div>

        <div class="details" *ngIf="viewModel.jobMetadata.customerType">
          <span class="title">Customer Type:</span>
          <span class="data"> {{ viewModel.jobMetadata.customerType }}</span>
        </div>

        <div class="details" *ngIf="viewModel.jobMetadata.jobOrigin">
          <span class="title">Job origin:</span>
          <span class="data"> {{ viewModel.jobMetadata.jobOrigin }}</span>
        </div>

        <div class="details" *ngIf="viewModel.jobSource">
          <span class="title">Source:</span>
          <span class="data"> {{ viewModel.jobSource }} </span>
        </div>
        <div class="details" *ngIf="viewModel.customer?.billingAddress">
          <span class="title">Billing Address:</span>
          <span class="data" *ngIf="viewModel.customer.billingAddress">
            <span *ngIf="viewModel.customer.billingAddress.addressLineTwo">
              {{ viewModel.customer.billingAddress.addressLineTwo }} -
            </span>
            {{ viewModel.customer.billingAddress.addressLineOne }}
          </span>
        </div>
      </main>
    </ng-container>
  </section>

  <ng-template #customerEditForm>
    <app-job-create-customer
      [renderHeadless]="true"
      *ngIf="viewModel.isEditMode"
      [openEditModeByDefault]="true"
    ></app-job-create-customer>
  </ng-template>
  <ng-template #cancelButton>
    <div class="flex">
      <p-button
        class="cancelButton p-mr-2"
        [outlined]="true"
        label="Cancel"
        (onClick)="store.dispatch(actions.cancelEditCustomerButtonClicked())"
      />
      <p-button
        class="saveButton"
        icon="pi pi-check"
        label="Save"
        [disabled]="viewModel.buttonDisabledMessage || viewModel.jobNotInZone"
        [pTooltip]="viewModel.buttonDisabledMessage"
        (onClick)="store.dispatch(actions.acceptCustomerChanges())"
      />
    </div>
  </ng-template>

  <ng-template #loading>
    <main>
      <div *ngFor="let _ of [1, 2, 3]" class="details">
        <p-skeleton width="10rem" height="3rem" />
      </div>
    </main>
  </ng-template>
</ng-container>
